export const MODULE_NAME = 'sidebar';
export const EMITTER_KEY = {
  ADD_NEW_SNIPPET: 'EMITTER/ADD_NEW_SNIPPET',
  REMOVE_SNIPPET: 'EMITTER/REMOVE_SNIPPET',
};

export const SNIPPET_REMOVED = [
  'stamped-display',
  'stamped',
  'ryviu-featured',
  'ryviu',
  'wiser',
  'wiser-personalized-recommendations',
  'rivyo',
  'rivyo-reviews-display',
  'opinew-featured',
  'opinew-reviews',
  'article',
];

export const PLAN_NAMES = {
  trial: 'Free',
  starter: 'Starter',
  professional: 'Build',
  advance: 'Optimize',
  build: 'Build',
  optimize: 'Optimize',
  enterprise: 'Enterprise',
  trial2022: 'Free',
};
